import { sortItems } from '@utils/functions.js';

import httpClient from './httpClient';
import { getUnlinkItemMap } from './mapper';

export const duplicateItem = (id, uid, items, setItems, setIsLoading) => {
  setIsLoading(true);
  // CopyBlockItem resolves the block from the body `uid` and copies item `id`.
  // The {profileId}/{sid} path segments are required by the route template but the
  // controller doesn't read them, so we fill them with the block uid we already have.
  httpClient.put(`api/profiles/${uid}/blocks/${uid}/items/${id}/copy`, { uid }).then((res) => {
    if (res && res.data) {
      setItems(sortItems([...items, res.data]));
    }
    setIsLoading(false);
  });
};

export const getPageBlocks = (id, profileId, setList, setIsLoading = () => {}) => {
  httpClient
    .get(`api/profiles/${profileId}/pages/${id}`)
    .then((res) => {
      if (res && res.data) {
        const { blocks: sections } = res.data;
        setList(sections);
      }
    })
    .catch((error) => {
      console.log(error);
    })
    .finally(() => {
      setIsLoading(false);
    });
};

export const getInstagramList = (username, userId, setList, setIsSavingUsername, toggleUsernameModal) => {
  if (!username || !userId) {
    return;
  }
  setIsSavingUsername(true);
  httpClient
    // `userId` is the profile this list belongs to — the body already says so. The URL used a
    // `profileId` that is not a parameter here, so the call threw before it was made.
    .post(`api/profiles/${userId}/instagram-accounts2`, {
      profileId: userId,
      username,
    })
    .then((res) => {
      if (res && res.data) {
        const { data } = res;
        const items = data.mediaex.map((el) => getUnlinkItemMap(el));
        setList(items);
      }
      setIsSavingUsername(false);
      toggleUsernameModal();
    })
    .catch((error) => {
      console.log(error);
      setIsSavingUsername(false);
      toggleUsernameModal();
    })
    .finally(() => {
      setIsSavingUsername(false);
      toggleUsernameModal();
    });
};
/**
 * The endpoint a block's heading and design are saved to.
 *
 * `blockId` used to be read from nowhere — it is declared in no scope in this module — so every call
 * threw a ReferenceError before the request left the browser. Thirty-nine call sites went through
 * here, which is to say saving a heading was broken for every block type that uses this layer.
 */
export function getSectionHeadingPath(type, isPathDesign, blockId) {
  return isPathDesign ? `api/${type}-blocks/${blockId}/design` : `api/${type}-blocks/${blockId}`;
}

export function getUploadApiCall(formData, profileId) {
  return httpClient.post(`api/profiles/${profileId}/upload`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

export function uploadVideoFileApiCall(file, profileId) {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('source', 'custom');
  formData.append('type', 'VIDEO');
  return httpClient.post(`api/profiles/${profileId}/upload/video`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
}

export function toggleBlockPin(profileId, blockId, isPinned) {
  return httpClient.post(`api/profiles/${profileId}/blocks/${blockId}/pin`, { isPinned });
}

export function archiveBlock(profileId, blockId) {
  return httpClient.delete(`api/profiles/${profileId}/blocks/${blockId}`);
}

export function restoreBlock(profileId, blockId) {
  return httpClient.put(`api/profiles/${profileId}/blocks/${blockId}/restore`);
}

export function getArchivedBlocks(profileId) {
  return httpClient.get(`api/profiles/${profileId}/blocks/archived`);
}

export function permanentDeleteBlock(profileId, blockId) {
  return httpClient.delete(`api/profiles/${profileId}/blocks/${blockId}/permanent`);
}
